import { Icon } from '@acme/assets';
import { Link } from 'react-router-dom';

interface UserSessionProps {
  authLinkPath: string;
  onLogout: () => void;
}

export const UserSession = ({ authLinkPath, onLogout }: UserSessionProps) => {
  return (
    <Link
      to={authLinkPath}
      className="flex w-full items-center justify-between gap-3 rounded-lg px-3 py-3 font-inter font-medium leading-6 text-red-600 hover:bg-red-50 transition-colors mt-4"
      onClick={() => {
        onLogout();
      }}
    >
      <span>Выйти</span>
      <Icon name="arrow-right-to-bracket" size={20} color="#E02424" />
    </Link>
  );
};
